import {
    aggregatePaymentDateFromRows,
    buildPaymentMethodsPayload,
    createPaymentRow,
    syncSinglePaymentAmount,
} from './checkoutPayments';
import { cloneBatchDate, isSameCalendarDay } from './batchCheckoutDates';

export {
    cloneBatchDate,
    isSameCalendarDay,
} from './batchCheckoutDates';

export function createEmptyBatchSale(saleOccurredAt = new Date()) {
    return {
        key: `sale-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
        products: [],
        payments: [
            createPaymentRow({
                amountCents: 0,
                paymentDate: cloneBatchDate(saleOccurredAt),
            }),
        ],
        customerWillPayLater: false,
        amount: 0,
        observations: '',
    };
}

export function syncBatchSalePaymentDates(sales, previousSaleOccurredAt, nextSaleOccurredAt) {
    if (!(nextSaleOccurredAt instanceof Date) || Number.isNaN(nextSaleOccurredAt.getTime())) {
        return sales;
    }

    return sales.map((sale) => {
        if (sale.customerWillPayLater) {
            return sale;
        }
        const payments = (sale.payments || []).map((payment) => {
            if (!payment.paymentDate || isSameCalendarDay(payment.paymentDate, previousSaleOccurredAt)) {
                return {
                    ...payment,
                    paymentDate: cloneBatchDate(nextSaleOccurredAt),
                };
            }
            return payment;
        });
        return { ...sale, payments };
    });
}

export function buildBatchCheckoutPayload({
    salesChannel,
    saleOccurredAt,
    customerId,
    customerName,
    customerPhone,
    customerEmail,
    sales,
    forcePaid = false,
}) {
    return {
        customer: {
            id: customerId,
            name: customerName,
            phone: customerPhone,
            email: customerEmail,
        },
        sales_channel: { id: salesChannel },
        created_at: saleOccurredAt != null ? saleOccurredAt.toISOString() : undefined,
        shipping_method: {
            name: 'Retirada no local',
            cost: 0,
            delivery_days: 0,
        },
        sales: sales.map((sale) => {
            const paid = forcePaid || !sale.customerWillPayLater;
            const row = {
                products: sale.products,
                amount: sale.amount,
                observations: String(sale.observations || '').trim(),
                payment_details: {
                    paid,
                },
            };
            if (paid) {
                const paymentMethods = buildPaymentMethodsPayload(sale.payments);
                if (paymentMethods.length > 0) {
                    row.payment_methods = paymentMethods;
                }
                const aggregateDate = aggregatePaymentDateFromRows(sale.payments);
                if (aggregateDate != null) {
                    row.payment_details.payment_date = aggregateDate.toISOString();
                }
            }
            return row;
        }),
    };
}

export function filterBatchSaleErrors(resultErrors, saleIndex) {
    const prefix = `sales.${saleIndex}.`;
    const out = {};
    Object.entries(resultErrors || {}).forEach(([key, value]) => {
        if (key.startsWith(prefix) && value) {
            out[key.slice(prefix.length)] = value;
        }
    });
    return out;
}

/** Mantém valor do pagamento único alinhado ao total da venda. */
export function syncBatchSaleSinglePaymentAmount(sale) {
    if (!sale || sale.customerWillPayLater) {
        return sale;
    }
    return {
        ...sale,
        payments: syncSinglePaymentAmount(sale.payments || [], sale.amount || 0),
    };
}
